import { defineComponent, computed } from 'vue'
import { RouterView, useRoute, useRouter } from 'vue-router'
import { Tabbar, TabbarItem } from 'vant'
import homeIcon from '@/assets/tabbar/home.png'
import homeActiveIcon from '@/assets/tabbar/home-active.png'
import findIcon from '@/assets/tabbar/find.png'
import findActiveIcon from '@/assets/tabbar/find-active.png'
import gszjIcon from '@/assets/tabbar/gszj.gif'
import treasureIcon from '@/assets/tabbar/treasure.png'
import treasureActiveIcon from '@/assets/tabbar/treasure-active.png'
import myIcon from '@/assets/tabbar/my.png'
import myActiveIcon from '@/assets/tabbar/my-active.png'

// ==================== Tab 配置（对齐 49208 底部 5 项） ====================

interface TabConfig {
  key: string
  route: string
  text: string
  icon?: string
  activeIcon?: string
  /** 中间凸起按钮（高手之家），点击跳全屏页 */
  special?: boolean
}

const TABS: TabConfig[] = [
  { key: 'home', route: '/', text: '首页', icon: homeIcon, activeIcon: homeActiveIcon },
  { key: 'find', route: '/find', text: '图库', icon: findIcon, activeIcon: findActiveIcon },
  { key: 'gszj', route: '/gszj', text: '高手之家', special: true },
  {
    key: 'treasure',
    route: '/treasure',
    text: '寻宝',
    icon: treasureIcon,
    activeIcon: treasureActiveIcon,
  },
  { key: 'my', route: '/my', text: '我的', icon: myIcon, activeIcon: myActiveIcon },
]

const ROUTE_TAB_MAP: Record<string, string> = Object.fromEntries(TABS.map((t) => [t.route, t.key]))

// ==================== TabLayout ====================

export default defineComponent({
  name: 'TabLayout',
  setup() {
    const route = useRoute()
    const router = useRouter()

    const activeKey = computed(() => ROUTE_TAB_MAP[route.path] ?? 'home')

    const handleChange = (key: string) => {
      const target = TABS.find((t) => t.key === key)?.route
      if (target && route.path !== target) {
        router.push(target)
      }
    }

    return () => (
      <div class="pb-[calc(50px+env(safe-area-inset-bottom))]">
        <RouterView />
        {/* .layout-nav / .tab-special 样式来自 49208.css（原站底部导航 1:1） */}
        <div class="layout-nav">
          <Tabbar
            modelValue={activeKey.value}
            onUpdate:modelValue={handleChange}
            fixed={false}
            safeAreaInsetBottom
            activeColor="#07C160"
            inactiveColor="#646566"
          >
            {TABS.map((tab) => (
              <TabbarItem
                key={tab.key}
                name={tab.key}
                v-slots={{
                  icon: ({ active }: { active: boolean }) =>
                    tab.special ? (
                      <div class={['tab-special', active ? 'active' : '']}>
                        <img src={gszjIcon} alt="" />
                      </div>
                    ) : (
                      <img src={active ? tab.activeIcon : tab.icon} alt="" />
                    ),
                }}
              >
                {tab.text}
              </TabbarItem>
            ))}
          </Tabbar>
        </div>
      </div>
    )
  },
})
